export const landers = {
  color: "red-c-landers",
  hex: "#CE152D",
  bgTheme: "#CE152D"
};

